import { Component, EventEmitter, Input, OnChanges, Output, inject } from '@angular/core';
import { NOTIFICATIONS, NotificationsService } from 'src/app/core/service/notifications.service';
import { EditStatus } from '../pojo/fund-strategy-enums';
import { FundStrategyModel } from '../pojo/fund-strategy-export-classes';
import { OrganizationDTO } from "../../../organization/dto/OrganizationDTO";
import { SelectedItemStyle, SelectorComponent } from "../../../shared/component/inputs/selector/selector.component";
import {
  UnsavedChangesModalService
} from "../../../shared/component/unsaved-changes-modal-wrapper/service/unsaved-changes-modal.service";
import { ButtonComponent } from "../../../shared/component/buttons/button.component";
import { ModalDialogComponent } from "../../../shared/component/modal-dialog/modal-dialog.component";
import { InputComponent } from "../../../shared/component/inputs/input-component/input.component";


@Component({
  selector: 'app-fund-strategy-selector',
  templateUrl: './fund-strategy-selector.component.html',
  styleUrls: ['./fund-strategy-selector.component.scss'],
  imports: [
    ButtonComponent,
    ModalDialogComponent,
    InputComponent,
    SelectorComponent
]
})
export class FundStrategySelectorComponent implements OnChanges {
  private notificationsService = inject(NotificationsService);
  private unsavedChangesModalService = inject(UnsavedChangesModalService);

  @Input() data: FundStrategyModel[];
  @Input() selectedItem: FundStrategyModel;
  @Input() organization: OrganizationDTO;
  @Input() disabled = false;
  @Input() buttons = {
    confirm: true,
    copyModel: false,
    newModel: false,
    delete: false,
    decline: true,
    rename: false,
  };

  @Output() buttonClicked = new EventEmitter<EditStatus>();
  @Output() selectedItemChanged = new EventEmitter<FundStrategyModel>();
  @Output() inputChanged = new EventEmitter<string>();
  @Output() exportExcelEmitter = new EventEmitter<void>();

  show = {
    input: true,
    modalThinkTwice: false,
  };

  isNameEmpty = false;

  input: string;

  editStatus = EditStatus;

  allowSave = true;
  modelSelectedItemStyle = new SelectedItemStyle('Model', 'upper-case black-8');
  dateSelectedItemStyle = new SelectedItemStyle('Base period', 'upper-case black-8');
  deleteModalTextList: string[];

  ngOnChanges(): void {
    if (!this.data && this.organization) {
      this.data = [];
      this.input = this.organization.name;
    }
    this.buttons.confirm = Boolean(!this.data.length);
  }

  inputChangeEmitter(input: string): void {
    this.input = input;
    this.isNameEmpty = this.input.trim().length === 0;
    this.inputChanged.emit(input);
  }

  modelChanged(model: FundStrategyModel): void {
    if (!this.checkEditMode()) {
      return;
    }
    this.selectedItemChanged.emit(model);
  }

  addNewModelClicked(): void {
    if (!this.checkEditMode()) {
      return;
    }
    this.buttonClicked.emit(EditStatus.newModel);
    this.buttons.confirm = true;
    this.buttons.decline = true;
  }

  declineClicked(): void {
    this.buttonClicked.emit(EditStatus.decline);
    this.buttons.confirm = false;
    this.buttons.decline = false;
    this.input = null;
  }

  confirmClicked(): void {
    if (this.input) {
      this.buttonClicked.emit(EditStatus.confirm);
      this.buttons.confirm = false;
      this.buttons.decline = false;
      this.buttons.rename = false;
      this.isNameEmpty = false;
      this.input = null;
    } else {
      this.isNameEmpty = true;
      this.notificationsService.warning(NOTIFICATIONS.SAVE_MODEL_FIRST_WARNING);
    }
  }

  renameModel(): void {
    if (!this.checkEditMode()) {
      return;
    }
    this.show.input = true;
    this.buttons.rename = true;
    this.buttons.confirm = true;
    this.buttons.decline = true;
    this.input = this.selectedItem.name;
  }

  confirmRename(): void {
    if (this.input) {
      this.buttons.confirm = false;
      this.buttons.rename = false;
      this.buttons.decline = false;
      this.isNameEmpty = false;
      this.inputChanged.emit(this.input);
      this.input = null;
      this.buttonClicked.emit(this.editStatus.renameModel);
    }
  }

  closeModalDeleteModel(withUpdate: boolean): void {
    if (withUpdate) {
      this.buttonClicked.emit(this.editStatus.delete);
    }
    this.show.modalThinkTwice = false;
  }

  deleteModel(): void {
    if (!this.checkEditMode()) {
      return;
    }
    this.show.modalThinkTwice = true;
    this.deleteModalTextList = ['Model ' + this.selectedItem.name + ' will be deleted'];
  }

  checkEditMode(): boolean {
    if (this.unsavedChangesModalService.getIsInEditMode()) {
      this.notificationsService.warning(NOTIFICATIONS.UNSAVED_CHANGES_WARNING);
      return false;
    }
    return true;
  }
}

